module.exports = __webpack_public_path__ + "static/img/4.96b62ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/4.png
// module id = ZAI7
// module chunks = 0